<template>
  <b-container class="main-content Danke" v-if="loading">
    <div class="d-flex align-items-center">
      <strong>Lade Daten...</strong>
      <b-spinner type="grow" label="Loading..." class="loader ml-auto"></b-spinner>
    </div>
    <b-alert show variant="danger" v-if="error">Fehler beim laden!</b-alert>
  </b-container>
  <b-container class="main-content details-page" v-else>

    <p>Abstimmung vom {{ proposal.effectiveDate }}, {{ proposal.name }}</p>

    <p class="titel">Vielen Dank für Ihre Stimme!</p>
    
    <div>
      <router-link class="homelink" :to="{ name: 'home'}">Take me home</router-link>
    </div>
  </b-container>
</template>

<script>
import client from 'api-client';

export default {
  name: 'Danke',
  props: ['id'],
  data() {
    return {
      loading: true,
      error: false,
      proposals: {},
    };
  },
  created() {
    client
      .fetchProposal(this.id)
      .then(proposal => this.setProposal(proposal))
      .then(vote => this.setVote(vote))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });
  },
  methods: {
    setProposal(proposal) {
      this.proposal = proposal;
      this.loading = false;
    },
    setVote(vote) {
      this.vote = vote;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.titel {
  font-size: 2em;
  margin: 30px 0;
  width: 100%;
  text-align: center;
}
.homelink {
  color: black;
}
.loader{
  width: 3rem;
  height: 3rem;
}
</style>
